<div id="carousel1"  *ngIf="slides.length; else noCarousel" class="carousel slide main-carousel">
<ol class="carousel-indicators" style="z-index: 3;">
    <li
    *ngFor="let slide of slides; let i = index"
    data-bs-target="#carousel1"
    [attr.data-bs-slide-to]="i"
    [class.active]="i === 0">
    </li>
</ol>

<div class="carousel-inner">
    <div
    class="carousel-item"
    *ngFor="let slide of slides; let i = index; trackBy: trackByIndex"
    [class.active]="i === 0"
    >
    <img
        [src]="slide.imageUrl"
        class="d-block w-100 carousel-image"
        alt="Carousel Image"
    />

    <div class="overlay-shape">
        <div class="text-wrapper">
        <p class="shape_fnt" [style.color]="titleColor">{{ slide.title }}</p>
        <p class="para_fnt" [style.color]="descriptionColor">{{ slide.description }}</p>
        </div>
    </div>
    </div>
</div>


<a class="carousel-control-prev" style="z-index: 4;" href="#carousel1" role="button" data-bs-slide="prev">
    <span class="carousel-control-prev-icon rounded" style="border: 1px solid white; background-color: rgb(255, 255, 255,0.5);" aria-hidden="true"></span>
    <span class="visually-hidden">Previous</span>
</a>
<a class="carousel-control-next" style="z-index: 4;" href="#carousel1" role="button" data-bs-slide="next">
    <span class="carousel-control-next-icon rounded" aria-hidden="true" style="border: 1px solid white; background-color: rgb(255, 255, 255,0.5);"></span>
    <span class="visually-hidden">Next</span>
</a>
</div>

<ng-template #noCarousel>
<p>No banners available</p>
</ng-template>